module.exports = __webpack_public_path__ + "f1e11535e56c67698e263673f625103e.woff2";